import { Link } from "@remix-run/react";
import { Button } from "~/components/ui/button";
import { ArrowLeftIcon } from "@radix-ui/react-icons";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 px-4">
      <div className="space-y-4 text-center">
        <h1 className="text-6xl font-bold">404</h1>
        <h2 className="text-2xl font-semibold">Page Not Found</h2>
        <p className="text-muted-foreground">
          {"Sorry, we couldn't find the page you're looking for."}
        </p>
      </div>
      
      <Button asChild variant="outline">
        <Link to="/" className="gap-2">
          <ArrowLeftIcon className="size-4" />
          Back to Home
        </Link>
      </Button>
    </div>
  );
}
